import React, { useEffect, useMemo } from 'react';
import Accordion from '../../components/Accordion/Accordion';
import Input from '../../components/Input/Input';
import Quote from '../../components/Quote/Quote';
import Loader from '../../components/Loader/Loader';
import { AccountInfoSP } from '../PageLayout/PageLayout';
import { useSelector, useDispatch } from 'react-redux';
import { apiCall } from '../../APICalls/APICalls';
import {
    selectLoadingStatus,
    selectNotifications,
    selectNotificationFilters,
    setNotificationFilters,
    setPreviousNotificationFilters,
    getCurrentRevisionIndex,
    setActiveNotificationInfo,
    selectActiveNotificationInfo,
    selectActiveNotificationQuote,
    selectNotificationSearch,
    setNotificationSearch,
    getNotifications,
    selectCustomers,
    userCanSuggest,
    userCanApprove,
    hasPendingFlags,
    filterQuoteObjectsByInputDate,
    getAllNotifications
} from '../../store/quotesAndNotificationsSlice';
import {
    setSidePanelTitle,
    selectUserId,
    selectCredentials,
    setSidePanelOptions,
    selectSidePanelTitle
} from '../../store/pageLayoutSlice';
import {
	denyIcon,
	approveIcon,
	cautionIcon,
	messageBubbleIcon,
	expandDownIcon
} from '../../assets/Icons/Icons';
import './Notifications.css';
import RevisionMessages from '../Quotes/RevisionMessages';
import Actions from '../Quotes/Actions';

/**
* @param string notificationType
* @return svg
*/
function getIcon(notificationType){
    switch ( notificationType.toLowerCase() ){
        case 'denied':
            return denyIcon;

        case 'approved':
            return approveIcon;

        case 'pending':
            return cautionIcon;
        
        case 'approved with change':
            return cautionIcon;

        case 'message':
            return messageBubbleIcon;
        //no default
    }
}

/**
* @param object quoteObj
* @param object filters
* @param string userId
* @return object
*/
function getNotificationsFromQuote(quoteObj, filters, userId){
    const { status, type } = filters;
    //let revisionIndex = getCurrentRevisionIndex(quoteObj);
    let revisionIndex = 0;
    const notificationsArr = quoteObj.quote[ revisionIndex ].notifications;
    const notifications = notificationsArr.filter( notification => {
        return (
            notification.userId.toString() === userId.toString() && 
            ( status === notification.status || status === '' || status === 'All' ) && 
            ( type === notification.Type || type === '' || type === 'All' )
        );
    });
    return notifications;
}

/**  
* @param object quoteObj
* @param object notification
* @param int index
* @param function dispatch
* @return object
*/
function createNotificationContent(quoteObj, notification){
    return {
        content: <Quote view='notifications' quote={ quoteObj } />,
        headContent: <div className={`notification_hc_container ${ notification.status === 'Unread' ? "notification_hc_unread" : ''}`}>
                        <div className="notification_hc_flex">
                            <p className="notification_hc_label">Quote #: </p>
                            <p className="notification_hc_quote_number">
                                { quoteObj.quoteNumber }
                            </p>
                        </div>
                        <div className="notification_hc_flex">
                            <p className="notification_hc_label">Subject: </p>
                            <p className="notification_hc_quote_subject">
                                { quoteObj.quote[0].generalInformation.generalDetails.quoteSubject }
                            </p>
                        </div>
                        <div className="notification_type_icon">
                            { getIcon(notification.Type) }
                        </div>
                    </div>
    };
}

function handleNotificationClick(notificationInfo, activeInfo, filters, userId){
    //console.log(notificationInfo.quoteId, activeInfo.quoteId);
    if( notificationInfo.status.toLowerCase() === 'unread' && ( notificationInfo.quoteId !== activeInfo.quoteId || notificationInfo.notificationId !== activeInfo.notificationId ) ){
        let _status = filters.status === '' ? 'All' : filters.status;
        let _type = filters.type === '' ? 'All' : filters.type;
        const apiData = { userId: userId.toString(), status: _status, type: _type };
        apiCall('quotesAndNotifications/getSingleQuote',{quoteId: notificationInfo.quoteId}).then( res => {
            const notifiedQuote = filterQuoteObjectsByInputDate( res.data )[0];
            // const filtered = filterQuoteObjectsByInputDate(res.data);
            // const notifiedQuote = filtered.find( quote => quote.quoteId === notificationInfo.quoteId );
            if( notifiedQuote ){
                const revisionIndex = notifiedQuote.quote.findIndex( revision => revision.revisionNumber === notificationInfo.revisionNumber );
                if( revisionIndex !== -1 ){
                    const notificationIndex = notifiedQuote.quote[ revisionIndex ].notifications.findIndex( note => note.notificationId === notificationInfo.notificationId );
                    if( notificationIndex !== -1 ){
                        notifiedQuote.quote[ revisionIndex ].notifications[ notificationIndex ].status = 'Read';
                        apiCall('quotesAndNotifications/putQuote', notifiedQuote ).then( res => {
                        }).catch(e => console.log(e));
                    }
                }
            }
        }).catch(e => console.log(e));
    }
}

function Notifications(props){

    const dispatch = useDispatch();

    const userId = useSelector( selectUserId );
    const filters = useSelector( selectNotificationFilters ).previous;
    const quotesWithNotifications = useSelector( selectNotifications );
    const activeInfo = useSelector( selectActiveNotificationInfo );
    const loadingStatus = useSelector( selectLoadingStatus );
    const { quoteNumber, subject, customer } = useSelector( selectNotificationSearch );
    const customerInfoLength = useSelector( selectCustomers ).length;
    let notificationObjects;
    let notificationsArray = [];
    let unreadNotificationsArray = [];
    let readNotificationsArray = [];
    let isOpen;

    useEffect(()=>{
        if( customerInfoLength > 0 ){
            // dispatch( getAllNotifications( { userId: userId.toString(), status: 'Unread' } ) );
            // dispatch( setNotificationFilters({ filter: 'status', value: 'Unread' }));
            dispatch( getAllNotifications( { userId: userId.toString() } ) );
        }
    }, [dispatch, customerInfoLength]);

    useEffect(() => {
        const resizeHeader = () =>{
            const header = document.getElementById("notifications_content_header");
            const content = document.getElementById("notifications_wrapper");
            let width = (content.clientWidth).toString()+'px';
            console.log(width);
            header.setAttribute("width", width);///
        };
        window.addEventListener("resize", resizeHeader);
        return () => window.removeEventListener("resize", resizeHeader);
    }, []);

    const filteredNotifications = useMemo(() => { //filtering by search values
        let filtered = quotesWithNotifications;
        if( customer !== '' ){
            let _customer = customer.toLowerCase();
            filtered = filtered.filter( note => {
                return ( note.quote[0].generalInformation.customerInformation.customer.toLowerCase().includes(_customer) );
            });
        }
        if( subject !== '' ){
            let _subject = subject.toLowerCase();
            filtered = filtered.filter( note => {
                return ( note.quote[0].generalInformation.generalDetails.quoteSubject.toLowerCase().includes(_subject) );
            });
        }
        if( quoteNumber !== '' ){
            let _quoteNumber = quoteNumber.toLowerCase();
            filtered = filtered.filter( note => {
                return ( note.quoteNumber.toLowerCase().includes(_quoteNumber) );
            });
        }
        return filtered;
    }, [ quoteNumber, subject, customer, quotesWithNotifications ])

    filteredNotifications.forEach(quoteObj => {
        notificationObjects = getNotificationsFromQuote(quoteObj, filters, userId); //loop through quotes and get notifications
        notificationObjects.forEach((notification, i) => {
            isOpen = (quoteObj.quoteId === activeInfo.quoteId && notification.notificationId === activeInfo.notificationId);
            const notificationInfo = { //keep track of quote and notification info in order to update statuses
                quoteId: quoteObj.quoteId,
                revisionNumber: quoteObj.quote[ 0 ].revisionNumber,
                notificationId: notification.notificationId,
                status: notification.status
            };
            const {
                content,
                headContent
            } = createNotificationContent(quoteObj, notification); //generate notification html
            const noteElement = <Accordion
                                    contentDescription="Notification"
                                    headContent={ headContent }
                                    isTopAccordion={ false }
                                    iconRight={ expandDownIcon }
                                    iconRightAnimate={ true }
                                    key={ notification.notificationId + quoteObj.quoteId + quoteObj.quote[0].generalInformation.generalDetails.quoteSubject }
                                    onClick={ 
                                        () => {
                                            dispatch( setActiveNotificationInfo( notificationInfo ) );
                                            handleNotificationClick(notificationInfo, activeInfo, filters, userId);
                                        }
                                    }
                                    controlled={ true }
                                    isOpen={ isOpen }
                                >
                                    { content }
                                </Accordion>;
            if( notification.status === "Unread" ){
                unreadNotificationsArray.push(noteElement);
            } else {
                readNotificationsArray.push(noteElement);
            }
        });
    });

    notificationsArray = [...unreadNotificationsArray, ...readNotificationsArray];

    return (
        <>
            <div id="notifications_content_header">
                <h3>{filters.status ? filters.status : 'All' } Notifications</h3>
            </div>
            <div id="notifications_wrapper">
            
                { notificationsArray }
                {
                    notificationsArray.length === 0 &&
                    <div>
                        <p className="empty_message">There are no notifications that match the filter and/or search values.</p>
                    </div>
                }
                { (loadingStatus.notifications === 'loading' ||
                   loadingStatus.putSuggestion === 'loading' ||
                   loadingStatus.approveQuote === 'loading' ||
                   loadingStatus.denyQuote === 'loading' ||
                   loadingStatus.approveWithChange === 'loading' ||
                   loadingStatus.approveOnBehalf === 'loading' ||
                   loadingStatus.printQuote === 'loading') && <Loader /> }
            </div>
        </>
    );
}

function NotificationsSPC(props){

    const dispatch = useDispatch();
    const activeQuote = useSelector( selectActiveNotificationQuote );
    const activeInfo = useSelector( selectActiveNotificationInfo );
    const sidePanelTitle = useSelector( selectSidePanelTitle );
    const credentials = useSelector( selectCredentials );
    const quoteFilters = useSelector( selectNotificationFilters );
    const notificationSearch = useSelector( selectNotificationSearch );
    const {
        userId,
        userType
    } = credentials;

    const {
        role,
        permissions
    } = userType;

    let canRevise = false;
    let canSuggestModification = false;
    let canApprove = false;
    let canApproveOnBehalf = false;
    let canPrint = false;
    let canExport = false
    let quoteStatus;
    let suggestions = [];
    let modifications = [];
    //let reasonForDenial;
    let flags = [];
    let content;
    const sidePanelOptions = [];

    if ( activeQuote ){
        //let currentRevisionIndex = getCurrentRevisionIndex(activeQuote);
        let currentRevisionIndex = 0;
        quoteStatus = activeQuote.quote[currentRevisionIndex].status.toLowerCase();
        suggestions = [ ...activeQuote.quote[currentRevisionIndex].suggestions ];
        modifications = [ ...activeQuote.quote[currentRevisionIndex].modifications ];
        //reasonForDenial = activeQuote.quote[currentRevisionIndex].denialReason;
        flags = [ ...activeQuote.quote[currentRevisionIndex].flags ];

        canRevise = permissions.includes("Create Quote Revision");
        canApproveOnBehalf = permissions.includes("Approve On Behalf") && hasPendingFlags(flags);
        canApprove = permissions.includes("Approve Quote") && userCanApprove( activeQuote.quote[currentRevisionIndex], userId, role );
        canSuggestModification = permissions.includes("Suggest Modifications") && userCanSuggest( activeQuote.quote[currentRevisionIndex], userId );
        canPrint = permissions.includes("Print Quotes") && activeQuote.quote[currentRevisionIndex].status && quoteStatus === 'approved';
        canExport = permissions.includes("Export Quote") && quoteStatus === 'approved';
    }

    useEffect(()=>{
        let contentName = 'Search';
        if( activeQuote){  
            if( quoteStatus.toLowerCase() === 'denied' ){
                contentName = 'Messages';
                sidePanelOptions.push('Messages');
            } else if(canPrint || canExport || canApprove || canApproveOnBehalf || canSuggestModification || canRevise){
                if( quoteStatus === 'denied' || canRevise ){
                    contentName = 'Messages';
                    sidePanelOptions.push('Messages');
                } else {
                    contentName='Actions';
                }  
                sidePanelOptions.push('Actions'); 
            }
        }

        sidePanelOptions.push('Search');
        sidePanelOptions.push('Account');
        dispatch( setSidePanelTitle(contentName) );
        dispatch( setSidePanelOptions( sidePanelOptions ) );
    }, [ activeQuote ]);   

        switch( sidePanelTitle ){
            case 'Messages':
                content = <RevisionMessages 
                        activeQuote={ activeQuote }
                        canRevise={ canRevise }
                        suggestions={ suggestions }
                        modifications={ modifications }
                    />;
            break;
            case 'Actions':
                content = <Actions
                        userType={ userType }
                        flags={ flags }
                        canSuggest={ canSuggestModification }
                        canApprove={ canApprove }
                        canApproveOnBehalf={ canApproveOnBehalf }
                        canPrint={ canPrint }
                        canExport={ canExport }
                        activeQuote={ activeQuote }
                        activeQuoteInfo={ activeInfo }
                        credentials={ credentials }
                        quoteFilters={ quoteFilters }
                        view="notifications"
                    />;
            break;
            case 'Search':
                content = <Filters
                            notificationFilters={ quoteFilters }
                            notificationSearch={ notificationSearch }
                        />;
            break;
            case 'Account':
                content = <AccountInfoSP />;
            break;
            default:
                content = <Filters
                            notificationFilters={ quoteFilters }
                            notificationSearch={ notificationSearch }
                        />;
        }

    return (
        <div>
            { content }
        </div>
    );
}

function Filters(props){

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch( setSidePanelTitle('Search') )
    }, [ dispatch ]);

    const { status, type } = props.notificationFilters.current;

    const { customer, quoteNumber, subject } = props.notificationSearch;

    const customerInfo = useSelector( selectCustomers );
    const notifications = useSelector( selectNotifications );

    const customers = useMemo(() => {
        return customerInfo.map( customer => customer.customer );
    }, [ customerInfo ]);

    const { quoteNumbers, subjects } = useMemo(() => {
        let quoteNums = [];
        let subjectArr = [];
        notifications.forEach( note => {
            quoteNums.push( note.quoteNumber );
            subjectArr.push( note.quote[0].generalInformation.generalDetails.quoteSubject );
        });
        return {
            quoteNumbers: quoteNums,
            subjects: subjectArr
        };
    }, [ notifications ]);

    const userId = useSelector( selectUserId );

    function handleFilter(){
        // let _type = type.trim() === '' ? 'All' : type.trim();
        // let _status = status.trim() === '' ? 'All' : status.trim();
        let _type = type.trim();
        let _status = status.trim();
        if( _type !== '' && _status !== '' ){
            dispatch( getNotifications({ userId: userId.toString(), type: _type, status: _status }) );
            dispatch( setActiveNotificationInfo( { quoteId: null, revisionNumber: null, notificationId: null } ) );
            dispatch( setPreviousNotificationFilters() );
        } else if( _status !== '' ){
            dispatch( getAllNotifications( { userId: userId, status: _status } ) );
            dispatch( setActiveNotificationInfo( { quoteId: null, revisionNumber: null, notificationId: null } ) );
            dispatch( setPreviousNotificationFilters() );
        }
    }

    return (
        <div className="notifications_sp_filters">
            <div className="notifications_sp_input_container">
                <Input 
                    type="searchable"
                    value={ status }
                    handleChange={ 
                        (e) => dispatch( setNotificationFilters({ filter: 'status', value: e.target.value }) )
                    }
                    handleSelect={
                        (e) => dispatch( setNotificationFilters({ filter: 'status', value: e.target.textContent }) )
                    }
                    handleClearValue={
                        () => dispatch( setNotificationFilters({ filter: 'status', value: '' }) )
                    }
                    options={ ['Unread', 'Read'] }
                    placeHolder="Notification Status"
                />
            </div>
            <div className="notifications_sp_input_container">
                <Input 
                    type="searchable"
                    value={ type }
                    handleChange={ 
                        (e) => dispatch( setNotificationFilters({ filter: 'type', value: e.target.value }) )
                    }
                    handleSelect={
                        (e) => dispatch( setNotificationFilters({ filter: 'type', value: e.target.textContent }) )
                    }
                    handleClearValue={
                        () => dispatch( setNotificationFilters({ filter: 'type', value: '' }) )
                    }
                    options={ ['Pending', 'Approved', 'Approved With Change', 'Denied', 'Message' ] }
                    placeHolder="Notification Type"
                />
            </div>
            <div className="filter_button_container">
                <button
                    className="filter_button"
                    onClick={ handleFilter }
                >
                    Search
                </button>
            </div>
            <div>
                <h3 className="side_panel_title">
                    Filter
                </h3>
            </div>
            <div className="notifications_sp_input_container">
                <Input 
                    type="searchable"
                    value={ customer }
                    handleChange={ 
                        (e) => dispatch( setNotificationSearch({ field: 'customer', value: e.target.value }) )
                    }
                    handleSelect={
                        (e) => dispatch( setNotificationSearch({ field: 'customer', value: e.target.textContent }) )
                    }
                    handleClearValue={
                        () => dispatch( setNotificationSearch({ field: 'customer', value: '' }) )
                    }
                    options={ customers }
                    placeHolder="Customer"
                />
            </div>
            <div className="notifications_sp_input_container">
                <Input 
                    type="searchable"
                    value={ subject }
                    handleChange={ 
                        (e) => dispatch( setNotificationSearch({ field: 'subject', value: e.target.value }) )
                    }
                    handleSelect={
                        (e) => dispatch( setNotificationSearch({ field: 'subject', value: e.target.textContent }) )
                    }
                    handleClearValue={
                        () => dispatch( setNotificationSearch({ field: 'subject', value: '' }) )
                    }
                    options={ subjects }
                    placeHolder="Quote Subject"
                />
            </div>
            <div className="notifications_sp_input_container">
                <Input 
                    type="searchable"
                    value={ quoteNumber }
                    handleChange={ 
                        (e) => dispatch( setNotificationSearch({ field: 'quoteNumber', value: e.target.value }) )
                    }
                    handleSelect={
                        (e) => dispatch( setNotificationSearch({ field: 'quoteNumber', value: e.target.textContent }) )
                    }
                    handleClearValue={
                        () => dispatch( setNotificationSearch({ field: 'quoteNumber', value: '' }) )
                    }
                    options={ quoteNumbers }
                    placeHolder="Quote #"
                />
            </div>
        </div>
    );
}

export default Notifications;
export { NotificationsSPC };